import styled from 'styled-components'

export const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  padding: ${props => props.theme.spacing.sp24};
  z-index: 1000;
`

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  background-color: ${props => props.theme.colors.background.primary};
  border-radius: ${props => props.theme.primitives.radius.radius3};
  box-shadow: 0 16px 70px rgba(0, 0, 0, 0.2);
  overflow: hidden;
`

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-shrink: 0;
  padding: ${props => props.theme.spacing.sp16} ${props => props.theme.spacing.sp24};
  border-bottom: ${props => props.theme.stroke.default} solid ${props => props.theme.colors.border.subtle};
`

export const Title = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sp12};
`

export const Actions = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sp12};
`

export const Body = styled.div`
  display: flex;
  flex: 1;
  min-height: 0;
`

export const EditorArea = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
`

export const PreviewDisclaimer = styled.div`
  flex-shrink: 0;

  > div {
    border-radius: ${props => props.theme.primitives.radius.radius0};
    justify-content: center;
  }
`

export const Content = styled.div`
  flex: 1;
  overflow-y: auto;
  background-color: ${props => props.theme.colors.background.primary};
  background-image:
    radial-gradient(circle at 0 0, ${props => props.theme.colors.border.default} 1.5px, transparent 1.5px),
    linear-gradient(to right, ${props => props.theme.colors.border.subtle} 0.5px, transparent 0.5px),
    linear-gradient(to bottom, ${props => props.theme.colors.border.subtle} 0.5px, transparent 0.5px);
  background-size: 25px 25px;
  padding: ${props => props.theme.spacing.sp32};
`

export const Page = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => (props.isMobileView ? props.theme.spacing.sp24 : props.theme.spacing.sp40)};
  max-width: ${props => (props.isMobileView ? '390px' : '1000px')};
  margin: 0 auto;
  background-color: ${props => props.theme.colors.background.primary};
  border: ${props => props.theme.stroke.default} solid ${props => props.theme.colors.border.subtle};
  border-radius: ${props => props.theme.primitives.radius.radius3};
  padding: ${props => (props.isMobileView ? props.theme.spacing.sp16 : props.theme.spacing.sp24)};
  transition:
    max-width 0.3s ease-in-out,
    padding 0.3s ease-in-out,
    gap 0.3s ease-in-out;
`

export const PermissionAlert = styled.div`
  flex-shrink: 0;
  padding: ${props => props.theme.spacing.sp8} ${props => props.theme.spacing.sp24} 0;

  > div {
    margin-top: 0;
  }
`
